import { render, staticRenderFns } from "./BrMask.vue?vue&type=template&id=66c503e8&"
import script from "./BrMask.vue?vue&type=script&lang=js&"
export * from "./BrMask.vue?vue&type=script&lang=js&"
import style0 from "./BrMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports